var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"little-title-container"}},[_c('div',{staticClass:"little-title-border"}),_c('div',{staticClass:"little-title",style:({ width: _vm.titleWidth })},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"little-title-border"})])
}
var staticRenderFns = []

export { render, staticRenderFns }